import { render, staticRenderFns } from "./FontBackground.vue?vue&type=template&id=9ac2eeea&scoped=true&"
import script from "./FontBackground.vue?vue&type=script&lang=ts&"
export * from "./FontBackground.vue?vue&type=script&lang=ts&"
import style0 from "./FontBackground.vue?vue&type=style&index=0&id=9ac2eeea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ac2eeea",
  null
  
)

export default component.exports